import { hasFeature, hasCloud } from '@/utils'

export default {
  async navMenuItems({ commit }) {

    commit('SET_NAV_MENU_ITEMS', {
      hasOrders: await hasFeature('orders'),
      hasServices: await hasFeature('services'),
      hasErps: await hasFeature('erps'),
      hasSmsCampaign: await hasFeature('sms'),
      hasMaria: await hasFeature('maria'),
      hasCatalog: await hasFeature('catalog'),
      hasEmailCampaign: await hasFeature('email'),
      hasMessaging: await hasFeature('messaging'),
      hasCloud: await hasCloud(),
    })
  },
}
